export default "__VITE_ASSET__BVldaFaF__"